import { createTracker } from 'usage-tracker';
import events from '../../events.yaml';
let tracker;
const mockTracker = {
  track: () => ({}),
  clone: () => mockTracker
};
export const useTracker = properties => {
  if (window.jasmine || '__STORYBOOK_ADDONS' in window) {
    return mockTracker;
  }
  if (!tracker) {
    tracker = createTracker({
      events
    });
  }
  if (properties) {
    tracker.setProperties(properties);
  }
  return tracker;
};